/** Copyright © 2013-2026 DataYes, All Rights Reserved. */

import { MenuItem } from './types';

// 菜单
export const MENU: MenuItem[] = [
  {
    name: '发布管理',
    privilege: 'FEED_MANAGE_LIST',
    children: [
      {
        name: '图文',
        link: '/clue/list',
        activeRegExp: /\/clue\/\S*/,
        privilege: 'FEED_ORIGINAL_REPORT',
      },
      {
        name: '线索素材',
        link: '/material/list',
        privilege: 'FEED_ORIGINAL_MATERIAL',
      },
      {
        name: '课程',
        link: '/course/list',
        activeRegExp: /\/course\/\S*/,
        privilege: 'COLUMN_MANAGE',
      },
      {
        name: '专栏',
        link: '/column/list',
        activeRegExp: /\/(column|columnGoods)\/\S*/,
        privilege: 'COLUMN_MANAGE',
      },
      {
        name: '圈子',
        link: '/community/list',
        activeRegExp: /\/(community|communityGoods)\/\S*/,
        privilege: 'COMMUNITY_MANAGE',
      },
      {
        name: '训练营',
        privilege: 'TRAIN_CAMP_MANAGE',
        children: [
          {
            name: '训练营管理',
            link: '/traincamp/list',
            activeRegExp: /\/traincamp\/(create|edit|semester|class|content)\S*/,
          },
          {
            name: '班班管理',
            link: '/traincamp/monitor',
          },
          {
            name: '客户管理',
            link: '/traincamp/customer',
          },
        ],
      },
      {
        name: '组合',
        link: '/group/list',
        activeRegExp: /\/group\/\S*/,
        privilege: 'GROUP_MANAGE',
      },
      {
        name: '工具',
        link: '/tool/list',
        activeRegExp: /\/tool\/\S*/,
        privilege: 'TOOL_MANAGE',
      },
      {
        name: '策略',
        link: '/strategy/list',
        activeRegExp: /\/strategy\/\S*/,
        privilege: 'STRATEGY_MANAGE',
      },
      {
        name: '形态选股',
        link: '/strategy-tutorial/list',
        activeRegExp: /\/strategy-tutorial\/\S*/,
      },
      {
        name: '信息审核',
        link: '/information/audit',
        activeRegExp: /\/information\/\S*/,
        privilege: 'QA_SQUARE_MANAGE',
      },
      {
        name: '股票池',
        link: '/stockPool/list',
        activeRegExp: /\/stockPool\/\S*/,
        privilege: 'STOCKPOOL_MANAGE',
      },
      {
        name: '研报',
        link: '/paper/list',
        activeRegExp: /\/paper\/\S*/,
        privilege: 'TRUMP_PAPER_MANAGE',
      },
      {
        name: '直播',
        link: '/live/list',
        activeRegExp: /\/live\/\S*/,
        privilege: 'LIVE_SHOW_MANAGE',
      },
      {
        name: '主题产业链',
        link: '/theme',
        activeRegExp: /\/theme\/\S*/,
        privilege: 'CORE_THEME_MANAGE',
      },
      {
        name: '风口掘金',
        link: '/vanguard/weekly',
        activeRegExp: /\/vanguard\/\S*/,
        privilege: 'DECISION_VANGUARD',
      },
    ],
  },
  {
    name: '营销中心',
    children: [
      {
        name: '优惠券',
        link: '/coupon/list',
        activeRegExp: /\/coupon\/\S*/,
        privilege: 'COUPON_MANAGE',
      },
      {
        name: '代金券',
        link: '/voucher/list',
        activeRegExp: /\/voucher\/\S*/,
        privilege: 'VOUCHER_MANAGE',
      },
      {
        name: '渠道活码',
        link: '/live-code/list',
        activeRegExp: /\/live-code\/\S*/,
        privilege: 'LIVE_CODE_MANAGE',
      },
      {
        name: '引流管理',
        link: '/referral',
        privilege: 'SCRM_COST_MANAGE',
      },
      {
        name: '活动链接配置',
        link: '/setting/activity/link',
        privilege: 'ACTIVITY_LINK_MANAGE',
      },
      {
        name: '商城管理',
        link: '/mall',
        activeRegExp: /\/mall\/\S*/,
        privilege: 'STORE_MANAGE',
      },
    ],
  },
  {
    name: '分销管理',
    children: [
      {
        name: '商品管理',
        link: '/distribution/goods',
        privilege: 'SCRM_GOODS_MANAGE',
      },
      {
        name: '分享管理',
        link: '/distribution/share',
        privilege: 'SCRM_SHARE_MANAGE',
      },
      {
        name: '用户中心',
        link: '/distribution/user-center',
        privilege: 'SCRM_CUSTOMER_MANAGE',
      },
    ],
  },
  {
    name: '广告管理',
    children: [
      {
        name: '轮播图',
        link: '/advertisement/carousel',
        privilege: 'BANNER_MANAGE',
      },
      {
        name: '个股行情',
        link: '/advertisement/stock',
        privilege: 'TICKER_BANNER',
      },
      {
        name: '首页弹窗',
        link: '/advertisement/home/popup',
        privilege: 'BANNER_MANAGE',
      },
    ],
  },
  {
    name: '内容审核',
    children: [
      {
        name: '评论管理',
        link: '/review/comment',
        privilege: 'COMMENT_MANAGE',
      },
      {
        name: '敏感词管理',
        link: '/review/sensitive-word',
        privilege: 'NEWS_SENSITIVE_WORD_MANAGE',
      },
      {
        name: '人工审核',
        link: '/review/manual',
        activeRegExp: /\/review\/\S*/,
        privilege: 'NEWS_AUDIT',
      },
    ],
  },
  {
    name: '设置',
    children: [
      {
        name: '标签管理',
        link: '/setting/tag',
        privilege: 'TAG_MANAGE',
      },
      {
        name: '页面管理',
        children: [
          {
            name: '课堂推荐页',
            link: '/setting/page/course',
            privilege: 'ROBO_CLASS_ROOM',
          },
          {
            name: '金卡专栏',
            link: '/setting/page/gold-research',
            privilege: 'MEMBER_MANAGE',
          },
          {
            name: '基金频道',
            link: '/setting/page/fund',
            privilege: 'FUND_CHANNEL',
          },
          {
            name: '静态页',
            link: '/setting/page/static/list',
            privilege: 'STATIC_PAGE_MANAGE',
            activeRegExp: /\/setting\/page\/static\/\S*/,
          },
        ],
      },
      {
        name: '机构持仓',
        link: '/setting/organization',
        privilege: 'RENOWNED_ORG',
      },
      {
        name: '会员管理',
        link: '/setting/vip',
        privilege: 'MEMBER_MANAGE',
      },
      {
        name: '积分兑换',
        link: '/setting/integral',
        privilege: 'MEMBER_MANAGE',
      },
      {
        name: '金股擂台',
        link: '/setting/stock-challenge',
        privilege: 'ACTIVITY_LINK_MANAGE',
      },
      {
        name: '运营工具',
        link: '/setting/service-tools',
        privilege: 'ACTIVITY_LINK_MANAGE',
      },
      {
        name: '配置管理',
        link: '/setting/config',
        privilege: 'ACTIVITY_LINK_MANAGE',
      },
    ],
  },
  {
    name: '用户管理',
    children: [
      {
        name: '用户权限管理',
        link: '/wanchao/user',
        privilege: 'WANCHAO_MANAGE',
      },
    ],
  },
];
